import { CardComponentProps } from "@~/types/types";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { IconButton as V31IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { IconButton as DeprecatedIconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { useFeatureFlags } from "@~/flags/flags";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";

export function RemoveButton({
  product,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { title } = product;
  const { isJldsV31Enabled } = useFeatureFlags();
  const dispatchEvent = useProductCardEvent();

  const clickHandler = () => {
    dispatchEvent(productCardEvents.removeProduct);
  };

  return isJldsV31Enabled?.value ? (
    <V31IconButton
      icon={Close24PxOutlinedIcon}
      aria-label={`Remove ${title}`}
      data-component="RemoveButton"
      onClick={clickHandler}
      data-testid="remove-button"
      background="clear"
    />
  ) : (
    <DeprecatedIconButton
      IconComponent={Close24PxOutlinedIcon}
      aria-label={`Remove ${title}`}
      data-component="RemoveButton"
      onClick={clickHandler}
      data-testid="remove-button"
      variant="clear-dark"
    />
  );
}
